export default function scrollToCurrentMenuItem() {
  const container = document.querySelector(".nav-section-wrap");

  if (!container) return;

  const menu = container.querySelector("nav.primary-nav");
  if (!menu) return;

  // Determine the correct active item based on the body class
  let currentItem;
  if (document.body.classList.contains("single-offer")) {
    currentItem = menu.querySelector(".menu-item-object-offer");
  } else {
    currentItem = menu.querySelector(".current-menu-item");
  }

  if (!currentItem) return;

  // Calculate the position to scroll the item into the center
  const itemOffsetLeft = currentItem.offsetLeft;
  const itemWidth = currentItem.offsetWidth;
  const containerWidth = container.clientWidth;

  // Calculate the scroll position to center the item
  const scrollPosition = itemOffsetLeft - containerWidth / 2 + itemWidth / 2;

  // Scroll to the calculated position
  container.scrollTo({
    left: scrollPosition,
    behavior: "smooth",
  });
}
